import { take, put, call, fork, select } from 'redux-saga/effects'
import { FETCH_SPECS } from './constants'
import { fetchPhoneApi } from './services'
import { fetchSpecs } from './actions'

function* fetchSpecsWorker(customerId) {
  const state = yield select()
  const customer = state.devicebits.customer
  const response = yield call(fetchPhoneApi, customerId, customer)

  if (response) {
    yield put(fetchSpecs.success(response))
  }
}

function* fetchSpecsWatcher() {
  while (true) {
    const { customerId } = yield take(FETCH_SPECS['REQUEST'])
    yield call(fetchSpecsWorker, customerId)
  }
}

export default function* rootSaga() {
  yield fork(fetchSpecsWatcher)
}



// WEBPACK FOOTER //
// ./src/containers/Specs/sagas.js